export const MENTION_TOKEN = /([@#])\[([^\]\n]{1,120})\]\(([^)\n]+)\)/g;

export type MentionSuggestion =
  | {
      trigger: 'at';
      kind: 'member' | 'business';
      id: string;
      label: string;
      image?: string;
      personName?: string;
      personId?: string;
    }
  | {
      trigger: 'hash';
      kind: 'category' | 'subcategory';
      category: string;
      subCategory: string | null;
      label: string;
    };

export function mentionToken(item: MentionSuggestion) {
  if (item.trigger === 'at') {
    return `@[${item.label}](${item.kind === 'member' ? 'u' : 'b'}:${item.id})`;
  }
  if (item.kind === 'category') {
    return `#[${item.label}](c:${encodeURIComponent(item.category)})`;
  }
  return `#[${item.label}](s:${encodeURIComponent(item.category)}|${encodeURIComponent(item.subCategory || '')})`;
}

export function mentionLabel(token: string) {
  const match = token.match(/^([@#])\[([^\]]+)\]/);
  return match ? `${match[1]}${match[2]}` : token;
}

export function slicePreservingMentions(text: string, limit: number) {
  if (text.length <= limit) return text;
  let end = limit;
  for (const match of text.matchAll(MENTION_TOKEN)) {
    const start = match.index ?? 0;
    const finish = start + match[0].length;
    if (start < end && finish > end) {
      end = start;
      break;
    }
  }
  return text.slice(0, end);
}
